module.exports = __webpack_public_path__ + "static/img/图层18.f5f7ae4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层18.png
// module id = DYkT
// module chunks = 0